<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 15:29:39
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-17 15:39:19
 * @name: 注册成功
 * @Description: 注册成功
 * @FilePath: \project\src\views\register\registerSuccess.vue
 * @Author: desktop
-->
<template>
  <div class="registerSuccess">
    <div class="a"></div>
    <div class="container">
      <img src="@/assets/image/success.png"/>
      <font class="title">提交注册成功</font>
      <font class="detail">需等待内部审核，审核结果会以短信形式通知</font>
      <el-button type="primary" @click="back">返回登录</el-button>
    </div>
    <div class="b"></div>
  </div>
</template>
<script>
export default {
  name: 'registerSuccess',
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
}
</script>
<style lang="scss" scoped>
.registerSuccess {
  width: 100%;
  height: 100%;
  @extend .et-flex-column-center;
  .a {
    flex: 1;
  }
  .container {
    width: 100%;
    @extend .et-flex-column-center;
    img {
      width: 160px;
      height: 160px;
    }
    .title {
      margin: 20px 0;
      font-size: $Vars-font-mainTitle-size;
    }
    .detail {
      margin: 20px 0;
      font-size: $Vars-font-content-size;
    }
  }
  .b {
    flex: 2;
  }
}
</style>